module.exports = __webpack_public_path__ + "static/img/call.a5ca0528.png";